const loginRedirectSessionKey = 'entity_portal_auth_login_redirect_in_progress';
const loginRedirectSessionTtlMs = 2000;

const canUseSessionStorage = () => {
  return (
    typeof window !== 'undefined' &&
    typeof window.sessionStorage !== 'undefined'
  );
};

const clearRedirectFlag = () => {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(loginRedirectSessionKey);
};

const hasActiveRedirectFlag = (): boolean => {
  if (!canUseSessionStorage()) {
    return false;
  }

  const raw = window.sessionStorage.getItem(loginRedirectSessionKey);
  if (!raw) {
    return false;
  }

  const startedAt = Number.parseInt(raw, 10);

  // Clear legacy/non-numeric values from older builds to avoid sticky lockout.
  if (!Number.isFinite(startedAt)) {
    clearRedirectFlag();
    return false;
  }

  const isActive = Date.now() - startedAt < loginRedirectSessionTtlMs;
  if (!isActive) {
    clearRedirectFlag();
  }

  return isActive;
};

export const runLoginRedirectOnce = async (
  onRedirect: () => Promise<void>,
): Promise<boolean> => {
  if (!canUseSessionStorage()) {
    await onRedirect();
    return true;
  }

  if (hasActiveRedirectFlag()) {
    return false;
  }

  window.sessionStorage.setItem(loginRedirectSessionKey, String(Date.now()));

  window.setTimeout(() => {
    clearRedirectFlag();
  }, loginRedirectSessionTtlMs);

  try {
    await onRedirect();
    return true;
  } catch (error) {
    clearRedirectFlag();
    throw error;
  }
};
